import { render, staticRenderFns } from "./QueueList2.vue?vue&type=template&id=464b9d37&scoped=true&"
import script from "./QueueList2.vue?vue&type=script&lang=js&"
export * from "./QueueList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464b9d37",
  null
  
)

export default component.exports